export default "__VITE_ASSET__Diy6L$us__"